// extracted by mini-css-extract-plugin
module.exports = {"container":"Supporters_container__8ut80","title":"Supporters_title__gWYes","images":"Supporters_images___5L_w"};